<template>
  <div>
    <v-tabs
      ref="tabs"
      v-model="active"
    >
      <v-tab
        v-for="item in tabItems"
        :key="item.name"
        class="divider font-black"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <div
      v-if="loading"
      align="center" 
      justify="center"
    >
      <v-progress-linear
        indeterminate
        color="primary"
      />
    </div> 
    <div v-else>
      <v-tabs-items
        v-model="active"
        style="background:transparent"
      >
        <!-- Payroll -->
        <v-tab-item>
          <v-autocomplete
            v-model="payrollELetter"
            label="E Letter Types"
            :items="payrollELetterTypes"
            item-text="name"
            class="pt-5 px-3"
            autofocus
            style="background:white"
          />
          <payroll-e-letter-download-letter
            v-if="payrollELetter"
            :letter-type="payrollELetter"
            :years="years"
            :companies="companies"
            class="mb-2"
          />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
  export default {
    components: {
      PayrollELetterDownloadLetter: () => import('@/components/hris/payroll/e-letter/DownloadLetterCard'),
    },

    data () {
      return {
        tabItems: [
          { name: 'E Letters' },
        ],
        active: 0,
        loading: false,
        years: [],
        companies: [],
        payrollELetter: null,
        payrollELetterTypes: [
          { name: 'Bonus Letters' },
          { name: 'Increment Letters' },
          { name: 'Promotion Letters' },
          { name: 'Salary Adjustment Letters' },
        ],
      }
    },
    created () {
      this.loading = true

      Promise.all([
        this.$api.payrollPeriods().list('?year=distinct'),
        this.$api.hrisCompanies().list(),
      ])
        .then(([years, companies]) => {
          this.years = years.data

          this.companies = _.orderBy(companies.data, ['name'], ['asc'])
          this.companies.unshift({ id: 'ALL', name: 'All Companies' })

          this.loading = false
        })
    },
  }
</script>
